import PropTypes from 'prop-types';

import Card from '../Card';

import styles from './_index.module.scss';

const TopicLibraryCard = ({ chart, children = null, topicName = '' }) => {
  return (
    <Card className={styles['topic-library-card']} padding={'small'}>
      <div className={styles['topic-card-library-chart']}>{chart}</div>
      {topicName && (
        <div className={styles['topic-library-card-header-wrapper']}>
          <strong>{topicName}</strong>
        </div>
      )}
      {children}
    </Card>
  );
};

TopicLibraryCard.propTypes = {
  chart: PropTypes.node,
  children: PropTypes.node,
  topicName: PropTypes.string,
};

export default TopicLibraryCard;
